// extracted by mini-css-extract-plugin
export default {"table_title":"index_table_title__rgdik"};